// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-section {
  background-color: #e6e6e6;
}

.footer-clmn1 {
  padding-left: 0px;
}
/* 
.footer-heading {
  color: black;
  font-size: 20px;
  line-height: 26px;
  text-transform: capitalize;
  font-weight: 700;
  position: relative;
  padding-bottom: 0px;
} */

.footer-heading  {
  font-size: 1.5rem; /* Adjust size as needed */
  font-weight: 600;
  color: #F37021; /* The orange color similar to the image */
  position: relative;
  display: inline-block;
  letter-spacing: 0.05rem;
}


.getintouch{
  background-color: #F37021 ;
  padding: 5px 20px !important;
  display: flex;
  text-align: center;
  font-size: 14px;
  border-radius: 15px;
  max-width: 100%;
}

/*
.footer-heading::after {
  position: absolute;
  content: '';
  bottom: 0;
  left: 0;
  width: 50px;
  border-bottom: 2px solid #f55b14;
  border-radius: 5px;
}
*/

.footer-logo {
  width: 160px;
  height: auto;
}

.footer-logo a img {
  width: 100%;
  height: auto;
}

.company-details {
  color: black;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  max-width: 330px;
}

.footer-contact-details {
  width: 100%;
  height: 100px;
  border-radius: 10px;
  /* padding: 15px 30px; */
  background: e6e6e6;
  color: black;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.footer-contactbox {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.footer-contact-iconbox {
  width: 40px;
  height: 40px;
}

.footer-contact-iconbox i {
  color: black;
  font-size: 32px;
}

.footer-contact-content {
  margin-left: 10px;
}

.ft_hd {
  color: #b4b4b4;
  font-weight: 700;
  font-size: 18px !important;
  margin-top: 50px;
  margin-bottom: 10px !important;
}


.timetable {
  margin-top: 30px;
}

.time_list {
  color: #fff;
  font-size: 16px;
  line-height: 22px;
  padding: 15px 0;
  transition: 0.3s ease-in-out;
  border-bottom: 1px solid #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}





.quick-link {
  padding-left: 0;
  margin-bottom: 0;
}

.ql {
  list-style: none;
  padding: 2px 0;
  transition: 0.3s;
}

a{
  color: black !important;
}

.ql:hover span {
  margin-left: 5px;
  transition: 0.3s;
}

.ql span {
  margin-right: 10px;
  transition: 0.3s;
}

.ql span i {
  font-size: 14px;
}

.ql a {
  text-decoration: none;
  color: #c4dbea;
  transition: 0.3s ease-in-out;
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
  display: flex;
}

.ql a:hover {
  color: #3bb5ff;
  transition: 0.3s ease-in-out;
  text-decoration: none;
}

.social_con p {
  margin-bottom: 0;
  padding: 0;
  color: #fff;
  font-weight: 700;
}

.contact-no-heading {
  color: black !important;
  font-size: 20px;
  line-height: 26px;
  font-weight: 500;
  text-transform: uppercase;
  position: relative;
  padding-bottom: 0px;
}

/*
.contact-no-heading::after {
  position: absolute;
  content: '';
  bottom: 0;
  left: 0;
  width: 40px;
  border-bottom: 3px solid #fff;
  border-radius: 5px;
}
*/
.contact-no2 {
  color: #c4dbea;
  font-size: 15px;
  line-height: 22px;
  font-weight: 400;
  margin-bottom: 0;
  transition: 0.3s ease-in-out;
}
.contact-no2:hover {
  color: #3ab54a;
  transition: 0.3s ease-in-out;
}
.contact-no2 a {
  color: #c4dbea;
  transition: 0.3s ease-in-out;
}

.contact-no2 a:hover {
  color: #3ab54a;
  transition: 0.3s ease-in-out;
}



.email-address-heading {
  color: black !important;
  font-size: 20px;
  line-height: 26px;
  font-weight: 500;
  text-transform: uppercase;
  position: relative;
  padding-bottom: 0px;
}

/*
.email-address-heading::after {
  position: absolute;
  content: '';
  bottom: 0;
  left: 0;
  width: 40px;
  border-bottom: 3px solid #fff;
  border-radius: 5px;
}
*/
.location-heading {
  color: #252525;
  font-size: 24px;
  line-height: 30px;
  font-weight: bold;
}

.email-address2 {
  color: #c4dbea;
  font-size: 15px;
  line-height: 22px;
  font-weight: 400;
  margin-bottom: 0;
  transition: 0.3s ease-in-out;
}

.email-address2 a {
  color: #c4dbea;
  transition: 0.3s ease-in-out;
}

.email-address2:hover {
  color: #3bb5ff;
  transition: 0.3s ease-in-out;
}

.email-address2:hover {
  color: #3bb5ff;
  transition: 0.3s ease-in-out;
}

.location2 {
  color: #b4b4b4;
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  margin-bottom: 15px;
}

.subs-content {
  padding-bottom: 30px;
}

.footer-section .social_con {
  margin-top: 30px;
}

/*
.social_con .social_icons {
  padding: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 0px;
}
*/

.footer-section .social_con .social_icons {
  padding: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 0px;
  transition: 0.3s ease-in-out;
}

.footer-section .social_con .social_icons .icons {
  width: 40px;
  height: 40px;
  display: grid;
  position: relative;
  place-items: center;
  color: #fff;
  border: 1px solid #fff;
  /*    background-color: #f55b14;*/
  border-radius: 0;
  margin-right: 7px;
  transition: 0.3s ease-in-out;
}

/*
.footer-section .social_con .social_icons .icons::after{
  content: '';
  position: absolute;
  top: 1px;
  left: 1px;
  width: 52px;
  height: 38px;
  background: #252525;
  transition: 0.3s ease-in-out;
  clip-path: polygon(20% 0, 100% 0%, 79% 100%, 0% 100%);
}
.footer-section .social_con .social_icons .icons:hover::after{
  display: none;
  transition: 0.3s ease-in-out;
}
*/
.footer-section .social_con .social_icons .icons i {
  font-size: 16px;
  transition: 0.3s ease-in-out;
  color: #fff;
  position: relative;
  z-index: 1;
}

.footer-section .social_con .social_icons .icons i:first-child {
  margin-left: 0;
  transition: 0.3s ease-in-out;
}

.footer-section .social_con .social_icons .icons:hover {
  background: #fff;
  transition: 0.3s ease-in-out;
}

.footer-section .social_con .social_icons .icons:hover i {
  color: #3bb5ff;
  transition: 0.3s ease-in-out;
}

.footer-section .form-detailsbox {
  padding: 40px 30px;
  background: #363636;
  border-top: 4px solid #eb1329;
  border-right: none;
}

.footer-section .addressbox {
  border-bottom: none;
  padding-bottom: 0;
}

.footer-section .phonebox2 {
  border-bottom: none;
}

.footer-section .emailbox2 {
  border-bottom: none;
  padding-top: 0;
}

.contact_contentbox {
  width: 85%;
}

.footer-section .contact-no-heading {
  color: #fff;
}

.footer-section .email-address-heading {
  color: #fff;
}

.footer-section .location {
  color: #fff;
}


.footer_end {
  width: 100%;
  height: auto;
  margin-top: 50px;
/*    background: #eb1329;*/
  /*    border-top: 1px solid rgba(255, 255, 255, 0.3);*/
}

.footer-end-content {
  padding: 20px 0;
  border-top: 1px solid rgba(255,255,255,0.3);
}

.ft_end_txt {
  color: black;
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  margin-bottom: 0;
}

.ft_end_txt a {
  color: #c4dbea;
  transition: 0.3s ease-in-out;
}

.ft_end_txt2 {
  text-align: right;
}

.ft_end_txt a:hover {
  color: #3bb5ff;
  transition: 0.3s ease-in-out;
}

.footer_end-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

[class*="col-"] {
  float: left;
  padding: 10px;
}
/* 
@media all and (max-width: 1024px) {
  .getintouch{
    background-color: #F37021 ;
    padding: 2px 10px !important;
    display: flex;
    text-align: center;
    font-size: 12px;
    border-radius: 15px;
    max-width: 93%;
  }
} */`, "",{"version":3,"sources":["webpack://./src/app/footer/footer.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;AACA;;;;;;;;;GASG;;AAEH;EACE,iBAAiB,EAAE,0BAA0B;EAC7C,gBAAgB;EAChB,cAAc,EAAE,0CAA0C;EAC1D,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;;AAGA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;;;;;;;CAUC;;AAED;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,8BAA8B;AAChC;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;AAChC;;;;;;AAMA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;;;;;;CAUC;AACD;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;;;AAIA;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;;;;;;CAUC;AACD;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;CAQC;;AAED;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;;;;;;CAgBC;AACD;EACE,eAAe;EACf,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB,2BAA2B;EACzB,sDAAsD;AACxD;;AAEA;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;AACA;;;;;;;;;;;GAWG","sourcesContent":[".footer-section {\n  background-color: #e6e6e6;\n}\n\n.footer-clmn1 {\n  padding-left: 0px;\n}\n/* \n.footer-heading {\n  color: black;\n  font-size: 20px;\n  line-height: 26px;\n  text-transform: capitalize;\n  font-weight: 700;\n  position: relative;\n  padding-bottom: 0px;\n} */\n\n.footer-heading  {\n  font-size: 1.5rem; /* Adjust size as needed */\n  font-weight: 600;\n  color: #F37021; /* The orange color similar to the image */\n  position: relative;\n  display: inline-block;\n  letter-spacing: 0.05rem;\n}\n\n\n.getintouch{\n  background-color: #F37021 ;\n  padding: 5px 20px !important;\n  display: flex;\n  text-align: center;\n  font-size: 14px;\n  border-radius: 15px;\n  max-width: 100%;\n}\n\n/*\n.footer-heading::after {\n  position: absolute;\n  content: '';\n  bottom: 0;\n  left: 0;\n  width: 50px;\n  border-bottom: 2px solid #f55b14;\n  border-radius: 5px;\n}\n*/\n\n.footer-logo {\n  width: 160px;\n  height: auto;\n}\n\n.footer-logo a img {\n  width: 100%;\n  height: auto;\n}\n\n.company-details {\n  color: black;\n  font-size: 14px;\n  line-height: 22px;\n  font-weight: 400;\n  max-width: 330px;\n}\n\n.footer-contact-details {\n  width: 100%;\n  height: 100px;\n  border-radius: 10px;\n  /* padding: 15px 30px; */\n  background: e6e6e6;\n  color: black;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.footer-contactbox {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.footer-contact-iconbox {\n  width: 40px;\n  height: 40px;\n}\n\n.footer-contact-iconbox i {\n  color: black;\n  font-size: 32px;\n}\n\n.footer-contact-content {\n  margin-left: 10px;\n}\n\n.ft_hd {\n  color: #b4b4b4;\n  font-weight: 700;\n  font-size: 18px !important;\n  margin-top: 50px;\n  margin-bottom: 10px !important;\n}\n\n\n.timetable {\n  margin-top: 30px;\n}\n\n.time_list {\n  color: #fff;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 15px 0;\n  transition: 0.3s ease-in-out;\n  border-bottom: 1px solid #fff;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n\n\n\n\n.quick-link {\n  padding-left: 0;\n  margin-bottom: 0;\n}\n\n.ql {\n  list-style: none;\n  padding: 2px 0;\n  transition: 0.3s;\n}\n\na{\n  color: black !important;\n}\n\n.ql:hover span {\n  margin-left: 5px;\n  transition: 0.3s;\n}\n\n.ql span {\n  margin-right: 10px;\n  transition: 0.3s;\n}\n\n.ql span i {\n  font-size: 14px;\n}\n\n.ql a {\n  text-decoration: none;\n  color: #c4dbea;\n  transition: 0.3s ease-in-out;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 400;\n  display: flex;\n}\n\n.ql a:hover {\n  color: #3bb5ff;\n  transition: 0.3s ease-in-out;\n  text-decoration: none;\n}\n\n.social_con p {\n  margin-bottom: 0;\n  padding: 0;\n  color: #fff;\n  font-weight: 700;\n}\n\n.contact-no-heading {\n  color: black !important;\n  font-size: 20px;\n  line-height: 26px;\n  font-weight: 500;\n  text-transform: uppercase;\n  position: relative;\n  padding-bottom: 0px;\n}\n\n/*\n.contact-no-heading::after {\n  position: absolute;\n  content: '';\n  bottom: 0;\n  left: 0;\n  width: 40px;\n  border-bottom: 3px solid #fff;\n  border-radius: 5px;\n}\n*/\n.contact-no2 {\n  color: #c4dbea;\n  font-size: 15px;\n  line-height: 22px;\n  font-weight: 400;\n  margin-bottom: 0;\n  transition: 0.3s ease-in-out;\n}\n.contact-no2:hover {\n  color: #3ab54a;\n  transition: 0.3s ease-in-out;\n}\n.contact-no2 a {\n  color: #c4dbea;\n  transition: 0.3s ease-in-out;\n}\n\n.contact-no2 a:hover {\n  color: #3ab54a;\n  transition: 0.3s ease-in-out;\n}\n\n\n\n.email-address-heading {\n  color: black !important;\n  font-size: 20px;\n  line-height: 26px;\n  font-weight: 500;\n  text-transform: uppercase;\n  position: relative;\n  padding-bottom: 0px;\n}\n\n/*\n.email-address-heading::after {\n  position: absolute;\n  content: '';\n  bottom: 0;\n  left: 0;\n  width: 40px;\n  border-bottom: 3px solid #fff;\n  border-radius: 5px;\n}\n*/\n.location-heading {\n  color: #252525;\n  font-size: 24px;\n  line-height: 30px;\n  font-weight: bold;\n}\n\n.email-address2 {\n  color: #c4dbea;\n  font-size: 15px;\n  line-height: 22px;\n  font-weight: 400;\n  margin-bottom: 0;\n  transition: 0.3s ease-in-out;\n}\n\n.email-address2 a {\n  color: #c4dbea;\n  transition: 0.3s ease-in-out;\n}\n\n.email-address2:hover {\n  color: #3bb5ff;\n  transition: 0.3s ease-in-out;\n}\n\n.email-address2:hover {\n  color: #3bb5ff;\n  transition: 0.3s ease-in-out;\n}\n\n.location2 {\n  color: #b4b4b4;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 500;\n  margin-bottom: 15px;\n}\n\n.subs-content {\n  padding-bottom: 30px;\n}\n\n.footer-section .social_con {\n  margin-top: 30px;\n}\n\n/*\n.social_con .social_icons {\n  padding: 0;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-top: 0px;\n}\n*/\n\n.footer-section .social_con .social_icons {\n  padding: 0;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-top: 0px;\n  transition: 0.3s ease-in-out;\n}\n\n.footer-section .social_con .social_icons .icons {\n  width: 40px;\n  height: 40px;\n  display: grid;\n  position: relative;\n  place-items: center;\n  color: #fff;\n  border: 1px solid #fff;\n  /*    background-color: #f55b14;*/\n  border-radius: 0;\n  margin-right: 7px;\n  transition: 0.3s ease-in-out;\n}\n\n/*\n.footer-section .social_con .social_icons .icons::after{\n  content: '';\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  width: 52px;\n  height: 38px;\n  background: #252525;\n  transition: 0.3s ease-in-out;\n  clip-path: polygon(20% 0, 100% 0%, 79% 100%, 0% 100%);\n}\n.footer-section .social_con .social_icons .icons:hover::after{\n  display: none;\n  transition: 0.3s ease-in-out;\n}\n*/\n.footer-section .social_con .social_icons .icons i {\n  font-size: 16px;\n  transition: 0.3s ease-in-out;\n  color: #fff;\n  position: relative;\n  z-index: 1;\n}\n\n.footer-section .social_con .social_icons .icons i:first-child {\n  margin-left: 0;\n  transition: 0.3s ease-in-out;\n}\n\n.footer-section .social_con .social_icons .icons:hover {\n  background: #fff;\n  transition: 0.3s ease-in-out;\n}\n\n.footer-section .social_con .social_icons .icons:hover i {\n  color: #3bb5ff;\n  transition: 0.3s ease-in-out;\n}\n\n.footer-section .form-detailsbox {\n  padding: 40px 30px;\n  background: #363636;\n  border-top: 4px solid #eb1329;\n  border-right: none;\n}\n\n.footer-section .addressbox {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.footer-section .phonebox2 {\n  border-bottom: none;\n}\n\n.footer-section .emailbox2 {\n  border-bottom: none;\n  padding-top: 0;\n}\n\n.contact_contentbox {\n  width: 85%;\n}\n\n.footer-section .contact-no-heading {\n  color: #fff;\n}\n\n.footer-section .email-address-heading {\n  color: #fff;\n}\n\n.footer-section .location {\n  color: #fff;\n}\n\n\n.footer_end {\n  width: 100%;\n  height: auto;\n  margin-top: 50px;\n/*    background: #eb1329;*/\n  /*    border-top: 1px solid rgba(255, 255, 255, 0.3);*/\n}\n\n.footer-end-content {\n  padding: 20px 0;\n  border-top: 1px solid rgba(255,255,255,0.3);\n}\n\n.ft_end_txt {\n  color: black;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n\n.ft_end_txt a {\n  color: #c4dbea;\n  transition: 0.3s ease-in-out;\n}\n\n.ft_end_txt2 {\n  text-align: right;\n}\n\n.ft_end_txt a:hover {\n  color: #3bb5ff;\n  transition: 0.3s ease-in-out;\n}\n\n.footer_end-row {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n}\n\n[class*=\"col-\"] {\n  float: left;\n  padding: 10px;\n}\n/* \n@media all and (max-width: 1024px) {\n  .getintouch{\n    background-color: #F37021 ;\n    padding: 2px 10px !important;\n    display: flex;\n    text-align: center;\n    font-size: 12px;\n    border-radius: 15px;\n    max-width: 93%;\n  }\n} */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
